/* eslint-disable no-unused-vars */
import axios from "utils/httpClient";
import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { Collapse, Modal, ModalBody } from "reactstrap";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Button from "components/CustomButtons/Button.js";
// import { Redirect } from "react-router-dom";
// core components
import styles from "assets/jss/material-dashboard-react/components/tableStyle.js";
import { Badge } from "reactstrap";
import EditIcon from "@material-ui/icons/Edit";
import Dashboard from "@material-ui/icons/Dashboard";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { blue, red } from "@material-ui/core/colors";
import Table2 from "components/Table/TableMonth";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useLocation
} from "react-router-dom";

const useStyles = makeStyles(styles);
const useStyles3 = makeStyles(theme => ({
  tableCell: {
    "&:hover": {
      backgroundColor: "tomato !important"
    },
    padding: "12px 8px",
    textAlign: "center"
  }
}));

const useStyles4 = makeStyles(theme => ({
  tableCell: {
    "&:hover": {
      backgroundColor: "green !important"
    },
    padding: "12px 8px",
    textAlign: "center"
  }
}));

const useStyles5 = makeStyles(theme => ({
  tableCell: {
    "&:hover": {
      // backgroundColor: "white !important"
    },
    padding: "12px 8px",
    textAlign: "center"
  }
}));

// const useStyles5 = makeStyles(theme => ({
//   tableRow: {
//     "&$hover:hover": {
//       backgroundColor: "white !important"
//     }
//   },
//   hover: {}
// }));

// export default function CustomTable(props) {
  export default function CustomTable(props) {
  // const [dataId, setDataId] = useState("");
  // const [option1, setOption1] = useState("");
  // const [option2, setOption2] = useState("");
  // const [option3, setOption3] = useState("");
  // const [option4, setOption4] = useState("");
  // const [redirect, setRedirect] = useState(false);
  const [modal, setModal] = useState(false);
  const classes = useStyles();
  const classes3 = useStyles3();
  const classes4 = useStyles4();
  const classes5 = useStyles5();
  const [tableHead2, setTableHead2] = useState([]);
  const [data, setData] = useState([]);
  const [icon, setIcon] = useState("fas fa-calendar-day");
  const {
    tableHead,
    tableData,
    tableHeaderColor,
    sortDirection: propSortDirection,
    onToggleSort
  } = props;

  const [internalSortDirection, setInternalSortDirection] = useState("asc"); // "asc" | "desc"
  const isControlledSort = propSortDirection !== undefined;
  const sortDirection = isControlledSort ? propSortDirection : internalSortDirection;

  const handleToggleSort = () => {
    if (isControlledSort && onToggleSort) {
      onToggleSort();
    } else {
      setInternalSortDirection(prev => (prev === "asc" ? "desc" : "asc"));
    }
  };

  const sortedTableData = useMemo(() => {
    if (!tableData || tableData.length === 0) return [];
    if (isControlledSort) {
      // If sort is controlled at the parent level, tableData is already sorted across all pages
      return tableData;
    }
    const list = [...tableData];
    list.sort((a, b) => {
      const nameA = (a[2] || "").toString().trim();
      const nameB = (b[2] || "").toString().trim();
      const cmp = nameA.localeCompare(nameB, "th", { numeric: true, sensitivity: "base" });
      return sortDirection === "asc" ? cmp : -cmp;
    });
    return list;
  }, [tableData, sortDirection, isControlledSort]);

  // const test = e => {
  //   if (e !== null) {
  //     setDataId(e[8]);
  //     setOption1(e[9]);
  //     setOption2(e[10]);
  //     if (e[11] !== null && e[11] !== undefined) {
  //       if (typeof e[11] !== "string") {
  //         setOption3(e[11]);
  //       } else {
  //         setOption3(0);
  //       }
  //     } else {
  //       setOption3(0);
  //     }
  //     if (e[12] !== null && e[12] !== undefined) {
  //       if (typeof e[12] !== "string") {
  //         setOption4(e[12]);
  //       } else {
  //         setOption4(0);
  //       }
  //     } else {
  //       setOption4(0);
  //     }
  //   }
  // };

  useEffect(() => {
    tableHead2.push(
      "ค่าเป้าหมาย",
      "ความถี่",
      "ตุลาคม",
      "พฤศจิกายน",
      "ธันวาคม",
      "มกราคม",
      "กุมภาพันธ์",
      "มีนาคม",
      "เมษายน",
      "พฤษภาคม",
      "มิถุนายน",
      "กรกฎาคม",
      "สิงหาคม",
      "กันยายน"
    );
  }, []);

  function tags(e) {
    return e[e.length - 1];
  }

  const handleCellEdit = e => {
    return "/datacenter/edit/" + e;
  };

  const handleCellClickModal = e => {
    axios("/api/v1/data/modalMonth?dataId=" + e[10])
      .then(response => response.data)
      .then(result => {
        var tableList = [];
        if (result.data.result.length > 0) {
          tableList.push([
            e[3],
            result.data.result[0],
            result.data.result[1],
            result.data.result[2],
            result.data.result[3],
            result.data.result[4],
            result.data.result[5],
            result.data.result[6],
            result.data.result[7],
            result.data.result[8],
            result.data.result[9],
            result.data.result[10],
            result.data.result[11],
            result.data.result[12]
          ]);
        }

        setData(tableList);
      });
    // console.log("test");
    // console.log(e);
    setModal(true);
  };

  // const handleCellClick = e => {
  //   var o1 = 0;
  //   var o2 = 0;
  //   var o3 = 0;
  //   if (e[11] === 2 && e[12] === "") {

  //       method: "GET"
  //     });
  //     const data = response.json();
  //     o1 = data.data.group1Id === null ? 0 : data.data.group1Id;
  //     o2 = data.data.group2Id === null ? 0 : data.data.group2Id;
  //     o3 = data.data.group3Id === null ? 0 : data.data.group3Id;
  //   } else if (e[11] === 1 && e[12] === "") {

  //       "/api/v1/dataReport?group1=" + e[11] + "&group2=" + e[12] + "&group3=" + e[13] + "&group4=" + e[14] + "&dataId=" + e[10],
  //       {
  //         method: "GET"
  //       }
  //     );
  //     const data3 =  response3.json();
  //     if (data3.data !== null) {
  //       o2 = data3.data.group2Id === null ? 0 : data3.data.group2Id;
  //       o3 = data3.data.group3Id === null ? 0 : data3.data.group3Id;
  //     } else {

  //         method: "GET"
  //       });
  //       const data2 =  response2.json();
  //       o1 = data2.data.group1Id === null ? 0 : data2.data.group1Id;
  //       o2 = data2.data.group2Id === null ? 0 : data2.data.group2Id;
  //       o3 = data2.data.group3Id === null ? 0 : data2.data.group3Id;
  //     }
  //   }
  
  //   var id = e[10];
  //   if (o1 === 0) {
  //     o1 = e[11];
  //   }
  //   if (o2 === 0) {
  //     o2 = e[12];
  //   }
  //   var o4 = 0;
  //   if (e[13] !== null && e[13] !== undefined && o3 === 0) {
  //     if (typeof e[13] !== "string") {
  //       o3 = e[13];
  //     }
  //   }
  //   if (e[14] !== null && e[14] !== undefined) {
  //     if (typeof e[14] !== "string") {
  //       o4 = e[14];
  //     }
  //   }

  //   props.history.push({
  //     pathname: 'dashboard',
  //     state: {
  //       dataId: id ,
  //       option1: o1,
  //       option2: o2,
  //       option3: o3,
  //       option4: o4
  //     }
  //   })
  // }

  const handleCellClick = e => {
    const fetchData = async () => {
      var o1 = 0;
      var o2 = 0;
      var o3 = 0;
      if (e[11] === 2 && e[12] === "") {
        const response = await axios("/api/v1/data/" + e[10], {
          method: "GET"
        });
        const data = response.data;
        o1 = data.data.group1Id === null ? 0 : data.data.group1Id;
        o2 = data.data.group2Id === null ? 0 : data.data.group2Id;
        o3 = data.data.group3Id === null ? 0 : data.data.group3Id;
      } else if (e[11] === 1 && e[12] === "") {
        const response3 = await axios(
          "/api/v1/dataReport?group1=" +
            e[11] +
            "&group2=" +
            e[12] +
            "&group3=" +
            e[13] +
            "&group4=" +
            e[14] +
            "&dataId=" +
            e[10],
          {
            method: "GET"
          }
        );
        const data3 = response3.data;
        if (data3.data !== null) {
          o2 = data3.data.group2Id === null ? 0 : data3.data.group2Id;
          o3 = data3.data.group3Id === null ? 0 : data3.data.group3Id;
        } else {
          const response2 = await axios("/api/v1/data/" + e[10], {
            method: "GET"
          });
          const data2 = response2.data;
          o1 = data2.data.group1Id === null ? 0 : data2.data.group1Id;
          o2 = data2.data.group2Id === null ? 0 : data2.data.group2Id;
          o3 = data2.data.group3Id === null ? 0 : data2.data.group3Id;
        }
      }

      var id = e[10];
      if (o1 === 0) {
        o1 = e[11];
      }
      if (o2 === 0) {
        o2 = e[12];
      }
      var o4 = 0;
      if (e[13] !== null && e[13] !== undefined && o3 === 0) {
        if (typeof e[13] !== "string") {
          o3 = e[13];
        }
      }
      if (e[14] !== null && e[14] !== undefined) {
        if (typeof e[14] !== "string") {
          o4 = e[14];
        }
      }

      window.location.href =
        "/datacenter/dashboard?dataId=" +
        id +
        "&option1=" +
        o1 +
        "&option2=" +
        o2 +
        "&option3=" +
        o3 +
        "&option4=" +
        o4;
    };
    fetchData().catch(error => console.error(error));
  };

  //   var id = e[8];
  //   var o1 =  e[9];
  //   var o2 = e[10];
  //   var o3 = 0;
  //   var o4 = 0;
  //   if (e[11] !== null && e[11] !== undefined) {
  //     if (typeof e[11] !== "string") {
  //       o3 = e[11];
  //     }
  //   }
  //   if (e[12] !== null && e[12] !== undefined) {
  //     if (typeof e[12] !== "string") {
  //       o4 = e[12];
  //     }
  //   }

  //   window.location.href = "/admin/dashboard?dataId=" +
  //   id +
  //   "&option1=" +
  //   o1 +
  //   "&option2=" +
  //   o2 +
  //   "&option3=" +
  //   o3 +
  //   "&option4=" +
  //   o4;
  // }

  // const test2 = () => {
  //   if (
  //     dataId !== "" &&
  //     option1 !== "" &&
  //     option2 !== "" &&
  //     option3 !== "" &&
  //     option4 !== ""
  //   ) {
  //     return (
  //       <Redirect
  //         from="/"
  //         to={
  //           "/admin/dashboard?dataId=" +
  //           dataId +
  //           "&option1=" +
  //           option1 +
  //           "&option2=" +
  //           option2 +
  //           "&option3=" +
  //           option3 +
  //           "&option4=" +
  //           option4
  //         }
  //       />
  //     );
  //   }
  // };

  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
          <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
            <TableRow className={classes.tableHeadRow}>
              {tableHead.slice(0, 4).map((prop, key) => {
                const isNameCol = prop === "ชื่อตัวชี้วัด";
                return (
                  <TableCell
                    className={classes.tableCell + " " + classes.tableHeadCell}
                    key={key}
                    onClick={isNameCol ? handleToggleSort : undefined}
                    style={
                      isNameCol
                        ? {
                            cursor: "pointer",
                            userSelect: "none"
                          }
                        : {}
                    }
                    title={
                      isNameCol
                        ? sortDirection === "asc"
                          ? "คลิกเพื่อสลับเรียงจาก ฮ - ก"
                          : "คลิกเพื่อสลับเรียงจาก ก - ฮ"
                        : undefined
                    }
                  >
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px"
                      }}
                    >
                      <span>{prop}</span>
                      {isNameCol && (
                        <span
                          style={{
                            fontSize: "12px",
                            backgroundColor: "rgba(255,255,255,0.25)",
                            padding: "2px 8px",
                            borderRadius: "12px",
                            display: "inline-flex",
                            alignItems: "center",
                            cursor: "pointer",
                            fontWeight: "normal"
                          }}
                        >
                          <i
                            className={
                              sortDirection === "asc"
                                ? "fa fa-sort-alpha-asc"
                                : "fa fa-sort-alpha-desc"
                            }
                            style={{ marginRight: "4px" }}
                          ></i>
                          {sortDirection === "asc" ? "ก - ฮ" : "ฮ - ก"}
                        </span>
                      )}
                    </div>
                  </TableCell>
                );
              })}

              {tableHead.slice(4, 10).map((prop, key) => {
                return (
                  <TableCell
                    className={classes.tableCell + " " + classes.tableHeadCell}
                    key={key}
                    style={{ textAlign: "center" }}
                  >
                    {prop}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {sortedTableData.length === 0 && (
            <TableRow>
              <TableCell
                colSpan={(tableHead && tableHead.length) || 10}
                style={{
                  textAlign: "center",
                  padding: "35px",
                  color: "#888",
                  fontSize: "15px"
                }}
              >
                <i
                  className="fa fa-folder-open-o"
                  style={{
                    fontSize: "32px",
                    display: "block",
                    marginBottom: "10px",
                    color: "#bbb"
                  }}
                ></i>
                ไม่พบข้อมูลตัวชี้วัด
              </TableCell>
            </TableRow>
          )}
          {sortedTableData.map((prop, key1) => {
            return (
              <TableRow
                key={key1}
                className={classes.tableBodyRow}
                style={{ cursor: "pointer" }}
                selected={true}
                hover={true}
                // onClick={() => test(prop)}
              >
                {prop[8] !== undefined
                  ? prop.slice(0, 4).map((prop2, key) => {
                      return (
                        // <TableCell className={classes.tableCell} key={key} onClick={() => handleCellClick(prop)}>
                        <TableCell
                          key={key}
                          style={{
                            backgroundColor: prop[16] ? "" : "Orange"
                          }}
                          className={
                            key !== 5 && prop[16]
                              ? classes5.tableCell
                              : classes3.tableCell
                          }
                          classes={{
                            hover:
                              key !== 5 && prop[16]
                                ? classes5.hover
                                : classes3.hover
                          }}
                          onClick={() => handleCellClickModal(prop)}
                        >
                          <h6>
                            {prop2 === "Dashboard" && (
                              <Dashboard
                                style={{
                                  color: red[500],
                                  fontSize: 30,
                                  cursor: "pointer"
                                }}
                                onClick={() => handleCellClick(prop)}
                              ></Dashboard>
                            )}
                            {prop2 === "Edit" && (
                              <Link to={() => handleCellEdit(prop[10])}>
                                <EditIcon
                                  style={{
                                    color: blue[500],
                                    fontSize: 30,
                                    cursor: "pointer"
                                  }}
                                ></EditIcon>
                              </Link>
                            )}
                            {prop2 !== "Dashboard" && prop2 !== "Edit" && (
                              <span
                                style={{
                                  color: prop[16] ? "" : "white"
                                }}
                              >
                                {prop2}
                              </span>
                            )}
                            {prop2 !== "Dashboard" && prop2 !== "Edit" && "   "}
                            {key === 2 &&
                            (prop2 !== "Dashboard" && prop2 !== "Edit") ? (
                              <Badge color="secondary">
                                {tags(prop)}
                              </Badge>
                            ) : (
                              ""
                            )}
                          </h6>
                          {/* {test2()} */}
                        </TableCell>
                      );
                    })
                  : prop.slice(3, 4).map((prop2, key) => {
                      return (
                        <TableCell className={classes.tableCell} key={key}>
                          <h6>{prop2}</h6>
                        </TableCell>
                      );
                    })}

                {prop[8] !== undefined
                  ? prop.slice(4, 9).map((propVal, key) => {
                      return (
                        <TableCell
                          key={key}
                          style={{ backgroundColor: "MediumSeaGreen" }}
                          className={classes4.tableCell}
                          classes={{ hover: classes4.hover }}
                        >
                          <h6 style={{ color: "white" }}>{propVal}</h6>
                        </TableCell>
                      );
                    })
                  : prop.slice(0, 1).map((propVal, key) => {
                      return (
                        <TableCell className={classes.tableCell} key={key}>
                          <h6>{propVal}</h6>
                        </TableCell>
                      );
                    })}

                {prop[8] !== undefined
                  ? prop.slice(9, 10).map((propVal, key) => {
                      return (
                        <TableCell
                          key={key}
                          style={{
                            backgroundColor: prop[15]
                              ? "MediumSeaGreen"
                              : "Orange"
                          }}
                          className={
                            key !== 5 && prop[15]
                              ? classes4.tableCell
                              : classes3.tableCell
                          }
                          classes={{
                            hover:
                              key !== 5 && prop[15]
                                ? classes4.hover
                                : classes3.hover
                          }}
                        >
                          <h6
                            style={{
                              color: prop[15] ? "white" : "white"
                            }}
                          >
                            {propVal}
                          </h6>
                        </TableCell>
                      );
                    })
                  : prop.slice(0, 1).map((propVal, key) => {
                      return (
                        <TableCell className={classes.tableCell} key={key}>
                          <h6>{propVal}</h6>
                        </TableCell>
                      );
                    })}
              </TableRow>
            );
          })}

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            toggle={() => setModal(false)}
            isOpen={modal}
          >
            <div className="modal-header justify-content-center">
              <div>
                <i
                  className={icon}
                  style={{ color: "blue", fontSize: "2em" }}
                ></i>
              </div>
            </div>
            <ModalBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <Table2
                    tableHeaderColor="info"
                    tableHead={tableHead2}
                    tableData={data}
                  />
                </GridItem>
              </GridContainer>
              {/* <p
                style={{
                  textAlign: "center"
                }}
              >
                {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                  ? "ยืนยันการบันทึกข้อมูล"
                  : "กำลังตรวจสอบข้อมูล"}
              </p>
              <p> </p> */}
            </ModalBody>
            <div className="modal-footer">
              <Button
                color="primary"
                type="button"
                onClick={() => setModal(false)}
              >
                <h4>ปิด</h4>
              </Button>

              {/* <Button
                color="primary"
                type="button"
                //onClick={}
                disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
              >
                <h4>ยืนยัน</h4>
              </Button> */}
            </div>
          </Modal>
        </TableBody>
      </Table>
    </div>
  );
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray"
};

CustomTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};

